// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\AddVessel\AddVesselRequest.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { OverrideServiceVessel, OverrideServiceVesselData, OverrideServiceVesselOptions } from 'data/models/OverrideServiceVessel';

// AddVesselRequestData is the class that AddVesselRequest serializes to/from
export interface AddVesselRequestData {
	
    LloydServiceVesselId : number | null;
    MarineTrafficServiceVesselId : number | null;
    OverrideServiceVessel : OverrideServiceVesselData | null;
    PSixServiceVesselId : number | null;
	
}

// AddVesselRequestOptions is the class which may be passed to the AddVesselRequest constructor to define optional initial data values
export interface AddVesselRequestOptions {
	
    LloydServiceVesselId? : number | null;
    MarineTrafficServiceVesselId? : number | null;
    OverrideServiceVessel? : OverrideServiceVesselOptions | null;
    PSixServiceVesselId? : number | null;
	
}

export class AddVesselRequest {
	
    public LloydServiceVesselId : DataSignal<number | null>;
    public MarineTrafficServiceVesselId : DataSignal<number | null>;
    public OverrideServiceVessel : DataSignal<OverrideServiceVessel | null>;
    public PSixServiceVesselId : DataSignal<number | null>;
	

    constructor();
    constructor(data : AddVesselRequestOptions);
    constructor(data: AddVesselRequestOptions | null = null) {
	    
        this.LloydServiceVesselId = jsonableObservable(S.value<number | null>(data && data.LloydServiceVesselId !== undefined ? data.LloydServiceVesselId : null));
        this.MarineTrafficServiceVesselId = jsonableObservable(S.value<number | null>(data && data.MarineTrafficServiceVesselId !== undefined ? data.MarineTrafficServiceVesselId : null));
        this.OverrideServiceVessel = S.value<OverrideServiceVessel | null>(null);
        this.PSixServiceVesselId = jsonableObservable(S.value<number | null>(data && data.PSixServiceVesselId !== undefined ? data.PSixServiceVesselId : null));
	    
    }

    static key(obj : AddVesselRequest) {
        return ;
    }
    
    static dataKey(obj : AddVesselRequestOptions) {
        return ;
    }

    static update(obj : AddVesselRequest, data : AddVesselRequestOptions) {
        S.freeze(() => {
	        
            if (data.LloydServiceVesselId !== undefined) obj.LloydServiceVesselId(data.LloydServiceVesselId);
            if (data.MarineTrafficServiceVesselId !== undefined) obj.MarineTrafficServiceVesselId(data.MarineTrafficServiceVesselId);
            if (data.PSixServiceVesselId !== undefined) obj.PSixServiceVesselId(data.PSixServiceVesselId);
	        
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/AddVesselRequest.ts